// @flow @jsx h

import {
  Figure,
  Heading,
  Paragraph,
  SerumSmartPicture
} from '@nrk/dh-feature-components'
import { bem } from '@nrk/dh-utils'
import { h } from 'preact'
import PureComponent from 'preact-pure-component'
import style from './index.css'
import VisualStory from '../VisualStory'

import type { SectionProps as Props } from './types'

type State = {
  seen: boolean
}

class Section extends PureComponent<Props, State> {
  elm: HTMLDivElement

  constructor (props: Props) {
    super(props)

    this.state = {
      seen: false
    }
  }

  componentDidMount () {
    this.props.onRegisterSectionElement(this.elm, this.props.index)
  }

  componentDidUpdate (prevProps: Props) {
    const { isIntersecting, onAnalyticsEvent } = this.props
    const { seen } = this.state

    if (!seen && isIntersecting && !prevProps.isIntersecting) {
      setTimeout(() => {
        this.setState({ seen: true })
      }, 0)

      onAnalyticsEvent({ action: `section/SHOW/${this.props.index}` })
    }
  }

  render () {
    const {
      index,
      intersections,
      isIntersecting,
      mediaBaseUrl,
      muted,
      onAnalyticsEvent,
      onRegisterTriggerElement,
      onToggleMute,
      type,
      viewport,
      value
    } = this.props

    const visible = isIntersecting

    switch (type) {
      case 'section':
        return (
          <div
            ref={elm => (this.elm = elm)}
            className={bem(style.section, { visible })}
          >
            {value.title && (
              <Heading className={style.section__heading} html={value.title} />
            )}
            {value.content && (
              <div className={style.section__content}>
                {value.content.map((item, idx) => {
                  switch (item.type) {
                    case 'text':
                      return (
                        <Paragraph
                          key={String(idx)}
                          className={style.article__paragraph}
                          html={item.value}
                        />
                      )

                    case 'figure':
                      return (
                        <Figure
                          media={
                            <SerumSmartPicture
                              horizontal={item.value.horizontal}
                              vertical={item.value.horizontal}
                              alt={item.value.alt}
                            />
                          }
                          caption={item.value.caption.map(text => text.value)}
                          credit={item.value.credit}
                        />
                      )

                    case 'visualStory':
                      return (
                        <VisualStory
                          {...item.value}
                          {...intersections[idx]}
                          mediaBaseUrl={mediaBaseUrl}
                          muted={muted}
                          onAnalyticsEvent={onAnalyticsEvent}
                          onToggleMute={onToggleMute}
                          onRegisterTriggerElement={onRegisterTriggerElement}
                          index={idx}
                          sectionIndex={index}
                          viewport={viewport}
                        />
                      )

                    default:
                      return <div key={String(idx)}>{item.type}</div>
                  }
                })}
              </div>
            )}
          </div>
        )

      default:
        return <div ref={elm => (this.elm = elm)}>{type}</div>
    }
  }
}

export default Section
